/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { z } from "zod";

const isValidateSchema = z.string().regex(/\S/);
export const itHasNotOnlyWhitespace = (value: string) => {
  if (value === "") {
    return true;
  }

  return isValidateSchema.safeParse(value).success;
};
